import React, { forwardRef, useContext } from 'react';
import OuterElementContext from './OuterElementContext';

const OuterElement = forwardRef(function OuterElementType(props, ref) {
  const outerProps = useContext(OuterElementContext);

  return <div ref={ref} {...props} {...outerProps} />;
});

export default OuterElement;
